import { useEffect, useMemo, useState } from 'react';
import BypassLoginDao from '../data/BypassLoginDao';
import { checkCookiesAndCsrf } from '../lib/LoginUtils';
import SsoRequiredAuthStatuses from '../constants/SsoRequiredAuthStatuses';
export const useBypass = ({
  skipBypass,
  loginPortalId,
  loginRedirectUrl
}) => {
  const [isBypassChecked, setIsBypassChecked] = useState(false);
  useEffect(() => {
    if (!skipBypass && loginPortalId) {
      const bypassLoginDao = new BypassLoginDao();
      bypassLoginDao.bypass({
        loginPortalId,
        loginRedirectUrl
      }).then(response => {
        if (response && response.status && response.status === SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED) {
          setIsBypassChecked(true); //return to smart login w/o any actions
        } else if (response && response.redirectUrl && response.redirectUrl.indexOf('login/jita') !== -1) {
          window.location.href = response.redirectUrl;
        } else {
          checkCookiesAndCsrf(loginPortalId).then(() => {
            window.location.href = response.redirectUrl;
          }).catch(() => {
            setIsBypassChecked(true);
          });
        }
      }).catch(() => {
        setIsBypassChecked(true);
      });
    } else {
      setIsBypassChecked(true);
    }
  }, [loginPortalId, loginRedirectUrl, skipBypass]);
  return useMemo(() => {
    return {
      isBypassChecked
    };
  }, [isBypassChecked]);
};